import React, { Component } from 'react';

import './navigate.scss';

export interface IProps {
    title: string;
    count: string;
}

export default class NavigateTwoLineItem extends Component<IProps, {}> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <>
                <div className="navigate-two-line-count">{this.props.count}</div>
                <div className="navigate-two-line-title">{this.props.title}</div>
            </>
        );
    }
}
